import { isTypeHeroQuoteSection } from '@platform/contentful';
import cx from 'classix';
import { Entry } from 'contentful';
import Quote from './util/Quote';

const ContentfulHeroQuoteSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeHeroQuoteSection(entry)) {
    return null;
  }

  return (
    <div
      className='flex flex-col justify-center -mx-4.5 py-6 sm:py-12  min-h-[75vh] bg-gray-50'
      style={{
        backgroundImage: `url(${entry.fields.image?.fields.file?.url})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'left',
      }}
    >
      <div
        className={cx(
          'flex flex-col bg-white sm:max-w-2/4 px-8 pb-6',
          'mx-6',
          entry.fields.cardAlignment === 'Left' ? 'sm:ml-auto sm:mr-[10%]' : 'sm:ml-[10%] sm:mr-6',
        )}
      >
        <Quote text={entry.fields.quote} quotee={entry.fields.quotee} />
      </div>
    </div>
  );
};

export default ContentfulHeroQuoteSection;
